import { WorkspaceInterface } from 'shared/types/workspace-interface'
import httpClient from 'modules/comments/api/http-client'

export const WORKSPACE_API = '/api/settings/workspace'
export const setWorkspace = (data: WorkspaceInterface) => httpClient.post(WORKSPACE_API, data)
